export default "__VITE_ASSET__DSiBX_dD__"